import React from 'react';
import { Button } from 'react-admin';
import LockIcon from '@material-ui/icons/Lock';
import makeStyles from '@material-ui/core/styles/makeStyles';
import cx from 'classnames';

const useStyles = makeStyles((theme) => ({
  warning: {
    color: theme.palette.warning.main,
  },
  red: {
    color: theme.palette.error.main,
  },
}));

interface Props {
  onClick?: () => void;
  warning?: boolean;
  red?: boolean;
  label?: string;
  [x: string]: any;
}

const BlockButton = (props: Props) => {
  const { onClick, warning, red, label, ...rest } = props;
  const classes = useStyles();

  return (
    <Button
      label={label || `components.ra.fields.BlockButton`}
      className={cx({ [classes.warning]: warning, [classes.red]: red })}
      onClick={onClick}
      {...rest}
    >
      <LockIcon />
    </Button>
  );
};

export default BlockButton;
